const database = {
    apiKey: "AIzaSyBmfb5lbJ29AdVQyp0Jk1Tug6pekx_fTwA",
    authDomain: "pq2-staging.firebaseapp.com",
    databaseURL: "https://pq2-staging.firebaseio.com",
    projectId: "pq2-staging",
    storageBucket: "pq2-staging.appspot.com",
    messagingSenderId: "438992683153"
};

export const environment = {
    production: false,
    database: database,
    pubQueueApiUrlEU: "https://dashboard2-ue6wk323oq-ew.a.run.app",
    pubQueuePaymentApiUrl: "https://payments2-ue6wk323oq-ew.a.run.app",
    dashboardApiUrl: "https://dashboard2-ue6wk323oq-ew.a.run.app",
    ApiUrl: "https://us-central1-pq2-staging.cloudfunctions.net",
    appVersion: '2.2.3'

}
